var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'surface-title-root': true,
    'transition-all duration-400 ease-in-out': true,
    'flex justify-start': true,
    'border-box': true,
    'overflow-visible': true,
    'w-full': true,
    'long-title': _setup.isLongTitle,
    'description-present': !!_setup.description,
    'portrait-present': !!_setup.portrait,
  }},[_c('div',{class:{
      'flex flex-shrink-0 items-center justify-center box-content': true,
      'w-10': !_setup.portrait,
      'w-8 h-8 ps-6 pe-4 pt-5.75': _setup.portrait,
      'animate-portrait-enter': !_vm.isCollapsed && _vm.isCollapsed !== null,
      'animate-portrait-leave': _vm.isCollapsed,
      'absolute top-0': true,
    },on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}},[(_setup.portrait)?_c(_setup.ProcessedImage,{staticClass:"rounded-lg",attrs:{"src":_setup.portrait,"width":_setup.PORTRAIT_SIZE,"height":_setup.PORTRAIT_SIZE,"transforms":{ preset: 'icon', width: _setup.PORTRAIT_SIZE, height: _setup.PORTRAIT_SIZE },"alt":_vm.__('Icon')}}):_vm._e()],1),_vm._v(" "),_c('div',{class:{
      'flex-shrink-0': true,
      'w-5 tablet-portrait:w-10': !_setup.portrait,
      'w-18': !!_setup.portrait,
      absolute: _vm.isCollapsed,
    }}),_vm._v(" "),_c('div',{class:{
      'w-full': true,
      'mt-3.5': !_vm.isCollapsed && !_setup.description,
      'mt-1.5': !_vm.isCollapsed && _setup.description,
    }},[_c(_setup.SurfaceBuilder,{class:{
        'text-body-extra-small': true,
        'animate-builder-enter': !_vm.isCollapsed && _vm.isCollapsed !== null,
        'animate-builder-leave': _vm.isCollapsed,
      }}),_vm._v(" "),_c('div',{staticClass:"flex flex-col",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}},[_c('div',{class:{
          'absolute flex ': true,
          'animate-title-collapse': _vm.isCollapsed,
          'animate-title-uncollapse': !_vm.isCollapsed && _vm.isCollapsed !== null,
          'mt-3 mb-3 ms-13.5': _vm.isCollapsed,
          'mt-0 me-4': !_vm.isCollapsed,
          'max-w-[calc(100%-160px)]': _vm.isCollapsed,
        }},[_c('h1',{class:{
            'w-full': true,
            'pe-2': _vm.isCollapsed && _setup.isLongTitle,
            [_setup.fontClass]: true,
            'whitespace-break-spaces': !_vm.isCollapsed,
            'whitespace-nowrap': _vm.isCollapsed,
            'text-ellipsis': _vm.isCollapsed,
            'overflow-hidden': _vm.isCollapsed,
            'text-heading-3': !_vm.isCollapsed,
            'text-heading-4 leading-6': _vm.isCollapsed,
            'font-semibold break-words': true,
            'text-dark-text-100': _setup.isMap ? _setup.colorScheme === 'light' : _setup.backgroundLuminance === 'light',
            'text-light-text-100': _setup.isMap ? _setup.colorScheme === 'dark' : _setup.backgroundLuminance === 'dark',
          },domProps:{"textContent":_vm._s(_setup.title || _vm.__('Untitled padlet'))}}),_vm._v(" "),_c('h1',{class:{
            absolute: true,
            'pe-2': _vm.isCollapsed,
            'w-full': true,
            [_setup.fontClass]: true,
            'whitespace-break-spaces': true,
            'text-heading-3': !_vm.isCollapsed,
            'text-heading-4 leading-6': _vm.isCollapsed,
            'animate-title-lines-fade-out-collapse': _vm.isCollapsed,
            'animate-title-lines-fade-in-uncollapse': !_vm.isCollapsed && _vm.isCollapsed !== null,
            'font-semibold break-words': true,
            'text-dark-text-100': _setup.isMap ? _setup.colorScheme === 'light' : _setup.backgroundLuminance === 'light',
            'text-light-text-100': _setup.isMap ? _setup.colorScheme === 'dark' : _setup.backgroundLuminance === 'dark',
          },domProps:{"textContent":_vm._s(_setup.title || _vm.__('Untitled padlet'))},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}})]),_vm._v(" "),_c('h1',{ref:"titleEl",class:{
          [_setup.fontClass]: true,
          'whitespace-break-spaces': true,
          'mt-6.5': _vm.isCollapsed,
          'me-4': !_vm.isCollapsed && !_setup.isLongTitle,
          'me-9': !_vm.isCollapsed && _setup.isLongTitle,
          'text-heading-3': true,
          invisible: true,
          'font-semibold break-words': true,
          'text-dark-text-100': _setup.isMap ? _setup.colorScheme === 'light' : _setup.backgroundLuminance === 'light',
          'text-light-text-100': _setup.isMap ? _setup.colorScheme === 'dark' : _setup.backgroundLuminance === 'dark',
        },domProps:{"textContent":_vm._s(_setup.title || _vm.__('Untitled padlet'))},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}}),_vm._v(" "),_c('div',{class:{
          'absolute flex-shrink-0 flex flex-row items-start': true,
          'w-full': _vm.isCollapsed,
        }},[_c('h1',{ref:"titlePlaceholderForCaretPosition",class:{
            [_setup.fontClass]: true,
            'mt-3 mb-3 ms-13.5': _vm.isCollapsed,
            'max-w-[calc(100%-180px)]': _vm.isCollapsed,
            'whitespace-break-spaces': !_vm.isCollapsed,
            'whitespace-nowrap': _vm.isCollapsed,
            'text-ellipsis': _vm.isCollapsed,
            'overflow-hidden': _vm.isCollapsed,
            'text-heading-3': !_vm.isCollapsed,
            'text-heading-4 leading-6': _vm.isCollapsed,
            invisible: true,
            'tablet-landscape:text-surface-title font-semibold break-words': true,
            'text-dark-text-100': _setup.isMap ? _setup.colorScheme === 'light' : _setup.backgroundLuminance === 'light',
            'text-light-text-100': _setup.isMap ? _setup.colorScheme === 'dark' : _setup.backgroundLuminance === 'dark',
          },on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('toggle-header')},"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-header')}}}),_vm._v(" "),_c('div',{class:{
            'h-6.5': !_vm.isCollapsed,
            'h-12': _vm.isCollapsed,
            'flex items-center': true,
          }},[_c(_setup.OzIcon,{class:{
              'animate-title-caret-collapse ': _vm.isCollapsed,
              'animate-title-caret-uncollapse ': !_vm.isCollapsed && _vm.isCollapsed !== null,
              'caret-just-mounted': _vm.isCollapsed === null,
              'ms-2': !_vm.isCollapsed,
              'text-dark-text-300': _setup.isMap ? _setup.colorScheme === 'light' : _setup.backgroundLuminance === 'light',
              'text-light-text-300': _setup.isMap ? _setup.colorScheme === 'dark' : _setup.backgroundLuminance === 'dark',
            },attrs:{"name":"chevron_right_center","size":12}})],1)]),_vm._v(" "),(_setup.description)?_c(_setup.SurfaceTitleDescription,{class:[
          'mt-0',
          'me-4',
          {
            'animate-description-enter': !_vm.isCollapsed && _vm.isCollapsed !== null,
            'animate-description-leave': _vm.isCollapsed,
          },
        ],attrs:{"text":_setup.description,"font-id":_setup.fontId,"color-scheme":_setup.isMap ? _setup.colorScheme : _setup.backgroundLuminance}}):_vm._e()],1),_vm._v(" "),_c('div',{class:{
        'h-3': !_vm.isCollapsed,
      }})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }